import type { Listing } from '@thevillages/schemas';

import { Component, inject, input, signal } from '@angular/core';

import { Environment } from '../../../../environments/environment';
import { StateService } from '../../../services/state/state';
import { SaveListing } from '../../save-listing/save-listing';

@Component({
  imports: [SaveListing],
  selector: 'app-listing-details-actions',
  styleUrl: './actions.css',
  templateUrl: './actions.html',
})
export class ListingDetailsActions {
  private readonly _stateService = inject(StateService);

  public readonly listing = input<Listing | undefined>();
  public readonly listingSaved = input(false);

  protected readonly isApp = signal(Environment.isApp);

  public directionsPostMessage(): void {
    if (!this.listing()) {
      return;
    }

    this._stateService.notifyParentOfStateChange('HF_EVENT:DIRECTIONS', {
      latitude: this.listing()?.geo.coordinates[1],
      longitude: this.listing()?.geo.coordinates[0],
    });
  }

  public openShareModal(): void {
    const _title = `Beautiful Home at ${this.listing()?.address.streetAddress} | HomeFinder`;
    const _text = this.listing()?.beds
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This condition is necessary until we update the logic to fit the new types package.
      ? `${this.listing()?.beds} bed / ${this.listing()?.baths?.value ?? this.listing()?.baths?.full} bath, ${this.listing()?.squareFeet?.total} sq ft in The Villages, FL.`
      : 'Home for sale in The Villages, FL.';

    if (this.isApp()) {
      this.sharePostMessage(_title, _text);
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This condition is necessary to check if the browser supports the Web Share API and if the device has touch capabilities.
    if (navigator.share && navigator.maxTouchPoints > 0) {
      void navigator.share({
        text: _text,
        title: _title,
        url: `${Environment.hostUrl}/${this.listing()?.id}`,
      });
    } else {
      this._stateService.isShareModalOpen.set(true);
    }
  }

  public sharePostMessage(title: string, text: string): void {
    if (!this.listing()) {
      return;
    }

    const _url = `${Environment.hostUrl}/${this.listing()?.id}`;

    this._stateService.notifyParentOfStateChange('HF_EVENT:SHARE', {
      imageUrl: this.listing()?.primaryImage,
      listingId: this.listing()?.id,
      text,
      title,
      url: _url,
    });
  }
}
